import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import MaxCalendar from '../components/MaxCalendar.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'MaxCalendar',
    component: MaxCalendar
  }
]

const router = new VueRouter({
  routes
})

export default router
